function BasicAccountIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 50 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y={0.428} width={14.341} height={14.341} rx={1.646} fill="#0891b2" />
      <rect
        x={36.208}
        y={0.976}
        width={13.244}
        height={13.244}
        rx={1.097}
        stroke="#06B6D4"
        strokeWidth={1.097}
      />
      <rect
        x={18.378}
        y={0.976}
        width={13.244}
        height={13.244}
        rx={1.097}
        stroke="#06B6D4"
        strokeWidth={1.097}
      />
    </svg>
  )
}

export default BasicAccountIcon
